export const SET_ROUTES_STATE = 'SET_ROUTES_STATE';

export function setRoutesState(data) {
    localStorage.setItem('initialized', "true");
    return {
        type: SET_ROUTES_STATE,
        data
    };
}
